import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingPriceInfo } from 'shared/components/NewbuildingPriceInfo';
import { PriceDiscount } from 'shared/components/PriceDiscount';
import { PriceElectronicTrading } from 'shared/components/PriceElectronicTrading/PriceElectronicTrading';
import { getOfferDiscount, isNewbuildingPageSelector, selectBookedFromDeveloperEnabled } from 'shared/selectors';
import { selectAsideCompactMode } from 'shared/selectors/aside';
import { selectIsBookedFromDeveloper } from 'shared/selectors/newbuildingBookedFromDeveloper';
import { isCoworkingSelector } from 'shared/selectors/offerData/offer/isCoworkingSelector';
import { isPriceElectronicTradingSelector } from 'shared/selectors/price';

import { PriceInfo } from '../../components/PriceInfo/PriceInfo';
import { PriceDropdownContainer } from '../../components/price_dropdown/container';
import { selectPriceAside } from '../../selectors/price/selectPriceAside';
import { withNoBreakSpaces } from '../../utils/formatters';
import { CoworkingAdditionalInfo } from '../CoworkingAdditionalInfo/CoworkingAdditionalInfo';
import { PriceHistoryContainer } from '../PriceHistory';
import { PurchaseTermsContainer } from '../PurchaseTermsContainer';
import { FullPriceContainer } from '../PurchaseTermsV2Container';

export const PriceContainer = () => {
  const price = useSelector(selectPriceAside);
  const isCoworking = useSelector(isCoworkingSelector);
  const isPriceAuction = useSelector(isPriceElectronicTradingSelector);
  const discount = useSelector(getOfferDiscount);
  const isCompactModeEnabled = useSelector(selectAsideCompactMode);
  const isNewbuilding = useSelector(isNewbuildingPageSelector);
  const isBooked = useSelector(selectIsBookedFromDeveloper);
  const bookedFromDeveloperEnabled = useSelector(selectBookedFromDeveloperEnabled);

  const isBookedFromDeveloper = isBooked && bookedFromDeveloperEnabled;

  if (isPriceAuction) {
    return <PriceElectronicTrading />;
  }

  if (!price) {
    return null;
  }

  const mainPrice = discount ? discount.newPrice : price;

  if (isNewbuilding) {
    return (
      <NewbuildingPriceInfo
        price={withNoBreakSpaces(mainPrice)}
        priceHistory={<PriceHistoryContainer />}
        discount={discount ? <PriceDiscount oldPrice={discount.oldPrice} percent={discount.percent} /> : null}
        isCompactModeEnabled={isCompactModeEnabled}
        purchaseTerms={<PurchaseTermsContainer />}
        fullPricePayment={<FullPriceContainer />}
        isBookedFromDeveloper={isBookedFromDeveloper}
      />
    );
  }

  return (
    <PriceInfo
      price={withNoBreakSpaces(mainPrice)}
      priceHistory={<PriceHistoryContainer />}
      priceInOtherCurrencies={!isCoworking ? <PriceDropdownContainer /> : null}
      coworkingAdditionalInfo={isCoworking ? <CoworkingAdditionalInfo /> : null}
    />
  );
};
